import { IApplicationState } from '../../types/redux';
import { IDeveloperV2 } from '../../types/developerV2/developer';

export const getBuilder = (state: IApplicationState) => {
  return (state.developerV2 as IDeveloperV2).builder;
};
